module.exports = __webpack_public_path__ + "static/media/9.78f15ee0.jpg";